import { render, staticRenderFns } from "./MlLabel.vue?vue&type=template&id=c3c20dbe&scoped=true&"
import script from "./MlLabel.vue?vue&type=script&lang=js&"
export * from "./MlLabel.vue?vue&type=script&lang=js&"
import style0 from "./MlLabel.vue?vue&type=style&index=0&id=c3c20dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c20dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
